import { StyleSheet } from "react-native";
import { theme } from "../../theme";
const allowedColors = Object.assign({}, ...Object.entries(theme.colors).map(([colorKey, value]) => {
    return { [colorKey]: { backgroundColor: value.base } };
}));
const circleDiameter = 14;
const lineHeight = 3;
export const styles = StyleSheet.create({
    ...allowedColors,
    divider: {
        width: "100%",
        height: lineHeight,
        alignSelf: "center",
        borderRadius: circleDiameter,
    },
    circle: {
        width: circleDiameter,
        height: circleDiameter,
        borderRadius: circleDiameter / 2,
        position: "absolute",
        top: -(circleDiameter - lineHeight) / 2,
    },
    circleRight: {
        right: 0,
    },
});
//# sourceMappingURL=Divider.styles.js.map